import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-field',
  templateUrl: './time-field.component.html',
  styleUrls: ['./time-field.component.scss']
})
export class TimeFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
